/* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import cn from 'classnames';
import * as React from 'react';
import { useEffect } from 'react';

import { IAgentSchema, IOfferSchema } from 'shared/types/api-models/offer-card/v1/get-offer-data';

import * as styles from './SimilarOffers.css';
import { SimilarOfferItem } from './components/SimilarOfferItem';
import { getSettings as getSlickSettings } from './slick/getSettings';
import './slick/slickCustomStyles.css';
import { getAnalyticsLabel } from './utils/getAnalyticsLabel';
import * as Analytics from '../../ebc/track_similar';
import { ISimilarOffer, TModelType } from '../../store/similar';
import { isArrayWithItems } from '../../utils';
import { getVariants } from '../../utils/ebc';
import { CustomSlider } from '../Slider';

export interface ISimilarOffersProps {
  title?: string | React.ReactNode;
  agent: IAgentSchema | null;
  offer: IOfferSchema;
  similarOffers: ISimilarOffer[];
  withoutCompetitors: boolean | null;
  modelVersion: number | string | null;
  modelType: TModelType;
  user: Analytics.IUserEBC;
  page: Analytics.IPageEBC;
  disableExternalContainerStyles?: boolean;
  slidesToShow?: number;

  requestSimilarOffers?(): void;
}

export const SimilarOffers = (props: ISimilarOffersProps) => {
  const { title, similarOffers, disableExternalContainerStyles, slidesToShow } = props;
  const slickSettings = getSlickSettings({ totalSlides: similarOffers.length, slidesToShow });
  const firstLabelIndex = similarOffers.findIndex(({ photoLabel }) => photoLabel && photoLabel.name);

  useEffect(() => {
    const { requestSimilarOffers } = props;
    /* istanbul ignore else */
    if (requestSimilarOffers) {
      requestSimilarOffers();
    }
  }, []);

  /* istanbul ignore next */
  const handleClickOffer = (curOffer: ISimilarOffer, position: number) => {
    const { agent, offer, withoutCompetitors, modelType, modelVersion: propsModelVersion, user, page } = props;
    const products: Analytics.TProductPartial[] = [
      {
        id: curOffer.cianId,
        position,
        ownerId: curOffer.publishedUserId || undefined,
        variant: curOffer.gaVariant ? getVariants(curOffer.gaVariant) : [],
      },
    ];
    const modelVersion = String(propsModelVersion || 0);

    Analytics.trackOfferClick({
      action: withoutCompetitors
        ? Analytics.EtrackOfferClicksActions.click_others_offers
        : Analytics.EtrackOfferClicksActions.click_similar_offers,
      label: getAnalyticsLabel(modelType, withoutCompetitors),
      products,
      agent,
      offer,
      modelVersion,
      user,
      page,
    });
  };

  if (!isArrayWithItems<ISimilarOffer>(similarOffers)) {
    return null;
  }

  return (
    <section
      className={cn(styles['container'], {
        [styles['disable-external-container-styles']]: disableExternalContainerStyles,
      })}
    >
      {typeof title === 'string' ? <h2 className={styles['title_block']}>{title}</h2> : title}
      <CustomSlider {...slickSettings} className="similar-offers-slider">
        {similarOffers.map((similarOffer, index) => (
          <SimilarOfferItem
            key={`similarOffer_${index}`}
            offer={similarOffer}
            withPhotoLabel={firstLabelIndex === index}
            onClick={handleClickOffer}
            position={index + 1}
          />
        ))}
      </CustomSlider>
    </section>
  );
};
